import './header.css';
import { isNonEmptyString } from '@thesavingsgroup/utils/isNonEmptyString';
import type { RemoteConfiguration } from '@thesavingsgroup/remote-configuration/types/RemoteConfiguration';

const Header = ({ configuration }: { configuration: RemoteConfiguration }) => {
  const { primaryLogo, heading, subheading } = configuration;

  const hasLogo = isNonEmptyString(primaryLogo);
  const hasHeading = isNonEmptyString(heading);
  const hasSubheading = isNonEmptyString(subheading);
  const showHeader = hasLogo || hasHeading || hasSubheading;

  if (!showHeader) {
    return null;
  }

  return (
    <div className="heading">
      {hasLogo && <img src={primaryLogo} alt="Logo" />}
      {hasHeading && <h1>{heading}</h1>}
      {hasSubheading && <h2>{subheading}</h2>}
    </div>
  );
};

export default Header;
